import { Users, DollarSign, Globe, Shield, CheckCircle } from "lucide-react"

const benefits = [
  {
    icon: Users,
    title: "Your price, your choice",
    description: "Set the price you want to pay. Receive offers from providers. Choose the best match.",
    stat: "2M+",
    statLabel: "Happy users",
    gradient: "from-blue-500/20 to-cyan-500/20",
  },
  {
    icon: DollarSign,
    title: "Real savings, real value",
    description: "Save up to 30% when providers compete for your booking. Every deal is negotiable.",
    stat: "30%",
    statLabel: "Average savings",
    gradient: "from-green-500/20 to-emerald-500/20",
  },
  {
    icon: Globe,
    title: "Local experiences, global reach",
    description: "Connect with authentic local providers for memorable experiences wherever you are.",
    stat: "50+",
    statLabel: "Countries",
    gradient: "from-purple-500/20 to-pink-500/20",
  },
  {
    icon: Shield,
    title: "Trusted and verified",
    description: "All providers are verified. Your bookings are secure. Your satisfaction guaranteed.",
    stat: "4.8/5",
    statLabel: "User rating",
    gradient: "from-[#DB4789]/20 to-pink-500/20",
  },
]

export function WhyChoose() {
  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-black via-[#0a0a0a] to-black relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#DB4789]/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#75055B]/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: "1s" }} />
      </div>

      {/* Grid pattern */}
      <div 
        className="absolute inset-0 opacity-40" 
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}
      />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#DB4789]/10 rounded-full mb-6 border border-[#DB4789]/20">
              <span className="text-sm font-semibold text-[#DB4789]">Why Choose Us</span>
            </div>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6">
              Why Choose StayApp
            </h2>
            <p className="text-lg text-white/70 max-w-2xl mx-auto">
              Fair prices and freedom to choose — that's the StayApp difference
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6 lg:gap-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="group bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 hover:border-[#DB4789]/50 transition-all duration-500 hover:bg-white/10 hover:shadow-2xl hover:shadow-[#DB4789]/20"
              >
                <div className="flex items-start gap-6 mb-6">
                  {/* Icon */}
                  <div className={`flex-shrink-0 w-16 h-16 rounded-2xl bg-gradient-to-br ${benefit.gradient} flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-500`}>
                    {benefit.icon ? (
                      <benefit.icon className="w-8 h-8 text-white" />
                    ) : (
                      <CheckCircle className="w-8 h-8 text-white" />
                    )}
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#DB4789] transition-colors duration-300">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>

                {/* Stats */}
                <div className="flex items-baseline gap-3 pt-6 border-t border-white/10">
                  <div className="text-3xl font-bold bg-gradient-to-r from-white to-[#DB4789] bg-clip-text text-transparent">
                    {benefit.stat}
                  </div>
                  <div className="text-sm text-white/60">{benefit.statLabel}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

